import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("app_atkey");
    if (token) {
      config.headers.Authorization = `bearer ${token}`;
    }
    return config;
  },
  (err) => {
    return Promise.resolve(err);
  }
);

interface dataCreateUser {
  registerBazeFactoryReducer: any[];
  error: string;
  success: boolean;
  isLoading: boolean;
}

const initialState: dataCreateUser = {
  registerBazeFactoryReducer: [],
  error: "",
  success: false,
  isLoading: false,
};

const registerBazeFactory = createSlice({
  name: "registerBazeFactoryReducer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // هنگام ارسال درخواست
      .addCase(getregisterBazeFactoryReducer.pending, (state) => {
        state.isLoading = true;
        state.error = "";
      })
      .addCase(getregisterBazeFactoryReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.registerBazeFactoryReducer = action.payload;
        state.success = true;
      })
      .addCase(getregisterBazeFactoryReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Something went wrong";
        state.success = false;
      })
      .addCase(addregisterBazeFactoryReducer.fulfilled, (state, action) => {
        if (Array.isArray(state.registerBazeFactoryReducer)) {
          state.registerBazeFactoryReducer.push(action.payload);
        } else {
          console.error(
            "registerBazeFactoryReducer is not an array:",
            state.registerBazeFactoryReducer
          );
        }
      })

      .addCase(deleteregisterBazeFactoryReducer.fulfilled, (state, action) => {
        state.registerBazeFactoryReducer =
          state.registerBazeFactoryReducer.filter(
            (data: any) => data.dataID !== action.payload.dataID
          ); // حذف registerBazeFactoryReducer
      })
      // عملیات به‌روزرسانی registerBazeFactoryReducer
      .addCase(updateregisterBazeFactoryReducer.fulfilled, (state, action) => {
        const index = state.registerBazeFactoryReducer.findIndex(
          (data) => data.dataID === action.payload.dataID
        );
        if (index !== -1) {
          state.registerBazeFactoryReducer[index] = action.payload; // به‌روزرسانی اطلاعات registerBazeFactoryReducer
        }
      });
  },
});

// ایجاد Thunks برای عملیات مختلف

// Thunk برای دریافت داده‌ها از سرور
export const getregisterBazeFactoryReducer = createAsyncThunk(
  "registerBazeFactoryReducer/getregisterBazeFactoryReducer",
  async (url: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(url);
      return response?.data?.items; // داده‌ها را از پاسخ axios استخراج می‌کنیم
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addregisterBazeFactoryReducer = createAsyncThunk(
  "registerBazeFactoryReducer/addData",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://api.havirkesht.ir/factory_seed/",
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error adding data user:", error);
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message || "Network Error";
        return rejectWithValue({
          message,
          status: error.response?.status,
        });
      }
      return rejectWithValue({
        message: "An unknown error occurred",
      });
    }
  }
);

export const deleteregisterBazeFactoryReducer = createAsyncThunk(
  "datafactory/deleteData",
  async (dataID: string, { rejectWithValue }) => {
    try {
      await axios.delete(`https://api.havirkesht.ir/factory_seed/${dataID}`);
      return { dataID }; // فقط شناسه DataFactory را بر می‌گردانیم
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

// Thunk برای به‌روزرسانی اطلاعات DataFactory
export const updateregisterBazeFactoryReducer = createAsyncThunk(
  "datafactory/updateData",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `https://api.havirkesht.ir/factory_seed/${data.id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);

      return rejectWithValue(error);
    }
  }
);

export default registerBazeFactory.reducer;
